<template>
    <div class="d-flex flex-column flex-lg-row gap-lg-1">
        <slot/>
    </div>
</template>

<script>
import FilterButton from "@components/Stats/FilterButton.vue";

export default {
    components: {FilterButton},
}
</script>
